import { MenuItem, ListItemIcon, ListItemText, Menu } from '@mui/material';
import { getSelectorAttribute, invoicesOverviewPageSelectors } from '@vy/app-selectors';
import { ArrowSmallRight, VyIcon } from '@vy/ui-design-system';
import { isNotNullOrUndefined } from '@vy/utils';
import { useMenu } from '../../../../../hooks/use-menu';

type DownloadMenuProps = {
  handleMenuClose: () => void;
  onDownloadAsPdf?: () => void;
  onDownloadAsPdfStatement?: () => void;
  onDownloadUsageEventsReport?: () => void;
  hasUsageEventsReportConfiguration?: boolean;
  disabled?: boolean;
};

export const DownloadMenu: React.FC<DownloadMenuProps> = ({
  handleMenuClose,
  onDownloadAsPdf,
  onDownloadAsPdfStatement,
  onDownloadUsageEventsReport,
  hasUsageEventsReportConfiguration,
  disabled,
}) => {
  const {
    isOpen: isDownloadMenuOpen,
    handleMenuOpen: handleDownloadMenuOpen,
    handleMenuClose: handleDownloadMenuClose,
    anchorElement: downloadMenuAnchorElement,
  } = useMenu();

  const handleMenuItemClick = (action?: () => void) => {
    return () => {
      handleMenuClose();
      action?.();
    };
  };

  return (
    <>
      <MenuItem
        onClick={handleDownloadMenuOpen}
        disabled={disabled}
        {...getSelectorAttribute(invoicesOverviewPageSelectors.dotsMenu.download)}
      >
        <ListItemIcon>
          <VyIcon
            icon="Download"
            color="black"
            style={{
              transform: 'scale(0.7)',
            }}
          />
        </ListItemIcon>
        <ListItemText>Download</ListItemText>
        <ArrowSmallRight />
      </MenuItem>

      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'center',
          horizontal: 'right',
        }}
        open={isDownloadMenuOpen}
        anchorEl={downloadMenuAnchorElement}
        onClose={handleDownloadMenuClose}
      >
        {isNotNullOrUndefined(onDownloadAsPdf) && (
          <MenuItem
            {...getSelectorAttribute(invoicesOverviewPageSelectors.dotsMenu.downloadPdf)}
            className="pl-4"
            onClick={handleMenuItemClick(onDownloadAsPdf)}
          >
            <ListItemText>Download invoice</ListItemText>
          </MenuItem>
        )}

        {isNotNullOrUndefined(onDownloadAsPdfStatement) && (
          <MenuItem
            {...getSelectorAttribute(invoicesOverviewPageSelectors.dotsMenu.exportStatement)}
            className="pl-4"
            onClick={handleMenuItemClick(onDownloadAsPdfStatement)}
          >
            <ListItemText>Export statement</ListItemText>
          </MenuItem>
        )}

        {hasUsageEventsReportConfiguration && isNotNullOrUndefined(onDownloadUsageEventsReport) && (
          <MenuItem
            {...getSelectorAttribute('download-usage-events-report')}
            className="pl-4"
            onClick={handleMenuItemClick(onDownloadUsageEventsReport)}
          >
            <ListItemText>Download usage events report</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
